<template>
    <v-menu
        ref="menu"
        v-model="openMenu"
        :close-on-content-click="false"
        :return-value.sync="date"
        transition="scale-transition"
        offset-y
        min-width="290px"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="dateString"
                :label="label ? label : ''"
                prepend-icon="mdi-calendar"
                append-icon=""
                :required="required"
                :rules="rules"
                readonly
                v-bind="attrs"
                v-on="on"
            >
                <template v-slot:append>
                    <v-btn elevation="1" x-small @click="() => $emit('input', undefined)">
                        {{ $t('common.clear') }}
                    </v-btn>
                </template>
            </v-text-field>
        </template>
        <v-date-picker
            ref="picker"
            v-model="date"
            :type="type || 'date'"
            :max="new Date().toISOString().substr(0, 10)"
            min="1910-01-01"
            @change="save"
        ></v-date-picker>
    </v-menu>
</template>

<script>
import Vue from 'vue'
export default Vue.extend({
    name: 'DateField',
    props: {
        value: Date || undefined,
        label: String,
        required: Boolean,
        rules: Array,
        type: String,
    },
    computed: {
        date: {
            get() {
                return this.value && !isNaN(this.value.getTime()) ? this.value.toISOString().substr(0, 10) : ''
            },
            set(newDate) {
                const newDateObj = new Date(this.type !== 'month' ? newDate : `${newDate}-01`)
                if (!isNaN(newDateObj.getTime())) this.$emit('input', newDateObj)
            },
        },
        dateString() {
            const options = {
                year: 'numeric',
                month: 'long',
                ...(this.type !== 'month' ? { day: 'numeric' } : {}),
            }
            return this.value ? this.value.toLocaleDateString(this.$i18n.locale, options) : ''
        },
    },
    data: () => ({
        openMenu: false,
    }),
    watch: {
        openMenu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
        },
    },
    methods: {
        save(date) {
            this.$refs.menu.save(date)
        },
    },
})
</script>

<style></style>
